import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import {
  AccidentClaimRequest,
  DeathClaimRequest,
  AccidentClaimDetail,
  DeathClaimDetail,
  ClaimListItem
} from '../models';

/**
 * Claims Service for IH API
 * Handles accident and death claims
 */
@Injectable({
  providedIn: 'root'
})
export class ClaimsService extends BaseHttpService {
  private readonly CLAIMS_ENDPOINT = 'claims';

  /**
   * Get accident claims list
   * GET /api/ih/claims/accident/list/{phone}
   */
  getAccidentClaims(phone: string): Observable<ClaimListItem[]> {
    return this.get<ClaimListItem[]>(`${this.CLAIMS_ENDPOINT}/accident/list/${phone}`);
  }

  /**
   * Get accident claim details
   * GET /api/ih/claims/accident/details/{id}
   */
  getAccidentClaimDetails(id: string): Observable<AccidentClaimDetail> {
    return this.get<AccidentClaimDetail>(`${this.CLAIMS_ENDPOINT}/accident/details/${id}`);
  }

  /**
   * Create accident claim
   * POST /api/ih/claims/accident
   */
  createAccidentClaim(request: AccidentClaimRequest): Observable<any> {
    return this.post<any>(`${this.CLAIMS_ENDPOINT}/accident`, request);
  }

  /**
   * Get death claims list
   * GET /api/ih/claims/death/list/{phone}
   */
  getDeathClaims(phone: string): Observable<ClaimListItem[]> {
    return this.get<ClaimListItem[]>(`${this.CLAIMS_ENDPOINT}/death/list/${phone}`);
  }

  /**
   * Get death claim details
   * GET /api/ih/claims/death/details/{id}
   */
  getDeathClaimDetails(id: string): Observable<DeathClaimDetail> {
    return this.get<DeathClaimDetail>(`${this.CLAIMS_ENDPOINT}/death/details/${id}`);
  }

  /**
   * Create death claim
   * POST /api/ih/claims/death
   */
  createDeathClaim(request: DeathClaimRequest): Observable<any> {
    return this.post<any>(`${this.CLAIMS_ENDPOINT}/death`, request);
  }

  /**
   * Cancel claim
   * DELETE /api/ih/claims/cancel/{id}
   */
  cancelClaim(id: string): Observable<any> {
    return this.delete<any>(`${this.CLAIMS_ENDPOINT}/cancel/${id}`);
  }
}
